import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  border-bottom: 1px solid ${(p) => p.theme.palette.grey[300]};
`;
